import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  imports: [ToastModule],
  templateUrl: './app-toast.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppToast {
  private readonly expandedKey = signal<string | null>(null);

  isExpanded(message: unknown): boolean {
    return this.expandedKey() === this.getMessageKey(message);
  }

  showAllIssues(message: unknown): void {
    this.expandedKey.set(this.getMessageKey(message));
  }

  private getMessageKey(message: unknown): string {
    const msg = message as Record<string, unknown> | null | undefined;
    const data = (msg?.['data'] as Record<string, unknown> | null | undefined) ?? null;

    const batchId = typeof data?.['batchId'] === 'string' ? data['batchId'].trim() : '';
    if (batchId) return `batch:${batchId}`;

    const id = typeof msg?.['id'] === 'string' ? msg['id'].trim() : '';
    if (id) return `id:${id}`;

    const summary = typeof msg?.['summary'] === 'string' ? msg['summary'] : '';
    const detail = typeof msg?.['detail'] === 'string' ? msg['detail'] : '';
    return `fallback:${summary}:${detail}`;
  }
}
